<section class="common__spacing--between-section">
  <div class="container-fluid">
    <div class="feature-section_heading text-align-center">
      <h2 class="secondary__heading">FAQs</h2>
    </div>
  </div>
</section>

<div class="faqPage">
  <div class="container-fluid">
    <article>
      <div class="accordion accordion--radio">
        <ng-container *ngFor="let faq of FaqList">
          <div class="tab">
            <input
              type="radio"
              name="accordion-2"
              class="{{ faq.id === checkedElement ? 'open' : '' }}"
              id="{{ faq.id }}"
              [checked]="faq.id === checkedElement ? true : null"
            />
            <label for="{{ faq.id }}" class="tab__label ellipsis" (click)="OpenFaq(faq.id)"
              >{{ faq.question }}
              <div class="searchBoxFaq">
                <!-- <img src="../../../../assets/images/Ic_drop_down_faq.svg" /> -->
                <span [innerHTML]="ICONS.circleDropdownIcon | safeHtml"></span>
              </div>
            </label>
            <div class="tab__content" *ngIf="faq.id === checkedElement">
              <div class="activity-list">
                <div class="activity-item ellipsis">
                  {{ faq.answer }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </article>
  </div>
</div>
